<template>
  <div class="has-integration-types-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
            Qual tipo de integração você deseja?
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 has-text-weight-bold mx-4 is-fullwidth"
                @click.prevent="setIntegrationType('cloud')"
            >
              <span>
                Integração Cloud
              </span>
            </button>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full">
            <span class="is-size-4 has-text-centered has-text-grey-dark has-text-weight-bold dm-sans mb-4">
              Diferenças integrações
            </span>
            <integration-diff-table integration-type="cloud"></integration-diff-table>
          </div>

          <div class="buttons is-flex is-justify-content-center is-full">
            <span class="is-size-4 has-text-grey-dark has-text-weight-bold dm-sans">
              Funções Inclusas
            </span>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full">
            <integration-functions-diff-table integration-type="cloud"></integration-functions-diff-table>
          </div>
        </div>

        <div class="column is-half">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 has-text-weight-bold mx-4 mb-5 is-fullwidth"
                @click.prevent="setIntegrationType('web')"
            >
              <span>Integração Web</span>
            </button>
          </div>
          <div class="buttons is-flex is-justify-content-center is-full mt-6">
            <integration-diff-table integration-type="web"></integration-diff-table>
          </div>

          <div class="buttons is-flex is-justify-content-center is-full mt-6 pt-5">
            <integration-functions-diff-table integration-type="web"></integration-functions-diff-table>
          </div>
        </div>
      </div>
      <div class="integrationTable" v-if="showIntegrationTypes">
        <div class="columns mt-4">
          <div class="column is-full">
            <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
              Qual?
            </p>
          </div>
        </div>
        <div class="columns mt-4">
          <div class="column is-full is-flex is-justify-content-center is-align-content-center">
            <div class="select is-large is-primary is-one-quarter">
              <select class="has-text-centered" v-model="formData.partner.data">
                <option disabled selected>Selecionar</option>
                <option :value="partner" v-for="(partner, index) in partners" :key="index">
                  {{ partner.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 pt-6" v-if="formData.partner.data && formData.partner.data.id">
      <next-button
          @nextTab="$emit('nextTab')"
          position="right"
          sizeClass="is-one-third"
      ></next-button>
    </div>
  </div>
</template>

<script>

import NextButton from './NextButton'
import IntegrationDiffTable from "./IntegrationDiffTable";
import IntegrationFunctionsDiffTable from "./IntegrationFunctionsDiffTable";

export default {

  name: 'integrationTypes',

  data() {
    return {
      showIntegrationTypes: false
    }
  },

  components: {
    NextButton,
    IntegrationDiffTable,
    IntegrationFunctionsDiffTable
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  methods: {
    setIntegrationType(type) {
      this.formData.integration.data.type = type
      this.$emit('nextTab')
      this.$emit('getPlans')
    }
  }

}

</script>
